
import { css } from 'lit';
export default css`
pc-grid div pc-accordion-baseline-panel:last-child{
  border-bottom:2px solid var(--purple-medium-neutral);
  margin-bottom:calc(2px * -1);
}
`;